<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/manuais">Manuais</router-link>
      </h3>
      <h4>{{ this.$route.query.c }} » {{ this.$route.query.sc!==undefined? this.$route.query.sc : '*'}}</h4>
    </div>
    <table>
      <tr>
        <td>#</td>
        <td></td>
        <td>Titulo</td>
        <td>Tags</td>
        <td>Data</td>
      </tr>
      <tr v-for="man in manuais">
        <td><a @click.prevent="select4edit(man.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><></td>
        <td>{{ man.titulo }}</td>
        <td>{{ man.tags }}</td>
        <td>{{ formatData(man.dt_insert) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'manuallist',
    data () {
      return {
        loading: false,
        manuais: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getmanual.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.manuais = response.body.rows
            } else {
              this.manuais = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/manual/u/${cod}`})
      },
      select4list (cod) {
        this.$router.push({path: `/manuais/${cod}`})
      },
      formatData (date) {
        return date.substring(8, 10) + '-' + date.substring(5, 7) + '-' + date.substring(0, 4)
      }
    },
    created: function () {
      const cat = this.$route.query.c
      const subcat = this.$route.query.sc
      this.load({'cat': cat, 'subcat': subcat})
    },
    watch: {
      '$route' (to, from) {
        const cat = this.$route.query.c
        const subcat = this.$route.query.sc
        this.load({'cat': cat, 'subcat': subcat})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 14px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    @media(max-width: 762px) {
      .container-fluid {
        width: 100vw;
        margin: 0px;
        padding: 5px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/ManRelCat.vue